import Skeleton from 'react-loading-skeleton';

import '../styles.scss';

const SidebarProfilePlaceholder = () => {
  return (
    <div className='sidebar_profile'>
      <Skeleton height={48} width={48} circle />
      <div className='sidebar_profile__info' style={{ gap: 0 }}>
        <div className='sidebar_profile__info__nickname'>
          <Skeleton height={18} width={222} />
        </div>
        <Skeleton />
        <Skeleton width={72} />
      </div>
    </div>
  );
};

export default SidebarProfilePlaceholder;
